import { render } from "./ActionHeader.vue?vue&type=template&id=7ff83b44"
import script from "./ActionHeader.vue?vue&type=script&lang=js"
export * from "./ActionHeader.vue?vue&type=script&lang=js"

import "./ActionHeader.vue?vue&type=style&index=0&id=7ff83b44&lang=scss"
script.render = render

export default script